import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider, QueryClient, QueryClientProvider } from './theme';
import '@fontsource-variable/noto-sans-sc';
import './web.css';
import '@desktop-renderer/styles/index.css';
import { AppShell } from './AppShell';
import { workbenchTheme, MotionConfig } from '@desktop-renderer/ui/theme';
import { RenderBoundary } from '@desktop-renderer/ui/render-boundary';

const root = document.getElementById('root');
if (!root) throw new Error('缺少应用挂载点。');
ReactDOM.createRoot(root).render(<React.StrictMode><MotionConfig reducedMotion="user"><FluentProvider theme={workbenchTheme}><RenderBoundary scope="app"><QueryClientProvider client={new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: Infinity } } })}><AppShell /></QueryClientProvider></RenderBoundary></FluentProvider></MotionConfig></React.StrictMode>);

